import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import ReloadWithFilters from 'src/javascripts/components/utilities/ReloadWithFilters';
import UsersTypeahead from 'src/javascripts/components/typeaheads/UsersTypeahead';
import Swal from 'sweetalert2';

export default class CompaniesIndex {

  constructor() {}

  render() {

    // Select all companies
    $('.select-all-companies').click(function() {
      $('#companies_table tr .checkbox').prop('checked', this.checked);
    });

    // Analysts typeahead
    if ( $(".users-typeahead").length > 0 )  {
      let analystsTypeahead = new UsersTypeahead('.users-typeahead');
      $.when(analystsTypeahead.initializeBloodhound() )
       .then( bloodhound => analystsTypeahead.render(bloodhound) )
       .then( analystsTypeahead.setUp('.users-typeahead'));
    }

  	// Init filter typeaheads
    filterTypeahead('.sector-filter', 'sectors', '/companies/attrs/search?attr=sector&', 40, 'generic');
    filterTypeahead('.industry-filter', 'industries', '/companies/attrs/search?attr=industry&', 115, 'generic');
    filterTypeahead('.sub-industry-filter', 'sub_industries', '/companies/attrs/search?attr=sub_industry&', 500, 'generic');
    filterTypeahead('.region-filter', 'regions', '/companies/attrs/search?attr=region&', 18, 'generic');
    filterTypeahead('.market-cap-filter', 'market_caps', '/companies/attrs/search?attr=market_cap&', 200, 'generic');

	  // On typeahead select, create a filter
	  $('.filter-companies-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {

	    // Prevent default
	    ev.preventDefault();

	    // Return if has class disabled
	    if ($(this).hasClass('disabled')) {return;}

	    // Hide tooltip
	    $('.tooltip').tooltip('hide');

	    // Set value to symbol if a fund; otherwise value
	    let val;
	    if (typeof suggestion.name !== 'undefined') {
	      val = suggestion.value;
	    } else if (typeof suggestion.value !== 'undefined') {
	      val = suggestion.value;
	    } else {
	      val = suggestion;
	    }

	    // Update attr in table
	    let attribute = $(this).attr('data-attribute');
	    $('.admin-table-fixed').attr('data-' + attribute, val);

	    // Reload
	    ReloadWithFilters('companies_table');

	  });

  	// Auto focus on typeahead when open a dropdown
		$('.dropdown').on('shown.bs.dropdown', function () {
			let input = $(this).find('input');
			if (typeof input !== 'undefined') {
				input.focus();
			}
  	})

    // Assign on select
    if ( $(".update-selected-companies").length > 0 )  {
      $('.update-selected-companies').click(function() {
        let attribute = $(this).attr('data-attribute');
        let attributeValue = $(this).attr('data-attribute-value');
        let companyIds = [];
        $.each( $('tr .checkbox:checkbox:checked'), function() {
          let recordId = $(this).closest('tr').attr('data-record-id');
          companyIds.push(recordId);
        })
        let params = {};
        params['attribute'] = attribute;
        params['attribute_value'] = attributeValue;
        params['company_ids'] = companyIds;
        $.ajax({
          type: 'PATCH',
          url: '/companies/bulk_assign?' + $.param(params),
          dataType: 'application/json',
          complete(result) { 
            let responseText = JSON.parse(result.responseText);
            $('#companies_table').DataTable().ajax.reload();
            ToastCustom('Updated', 'Company records updated', 5000);
            $('.select-all-companies').prop('checked', false);
          },
        });
      })
    }

    // Merge selected
    if ( $(".merge-selected-records").length > 0 )  {
      $('.merge-selected-records').click(function() {
        let confirmText = "Confirm you would like to merge the selected companies into one. "
        confirmText += "This will keep the company with 1) no TEMP symbol, or 2) the one with Production Ready status, "
        confirmText += "or 3) the most recently-reviewed company. "
        confirmText += "This action cannot be undone.";
        return Swal.fire({
          title: "Are you sure?",
          text: confirmText,
          animation: false,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-light border',
            popup: 'animated fadeIn faster'
          }
        }).then((result) => {
          if (result.value) {
            let companyIds = [];
            $.each( $('tr .checkbox:checkbox:checked'), function() {
              let recordId = $(this).closest('tr').attr('data-record-id');
              companyIds.push(recordId);
            })
            if (companyIds.length < 2) {
              return ToastCustom('Error', 'Please select at least two companies to merge', 10000);
            } else if (companyIds.length > 3) {
              return ToastCustom('Error', 'Please select no more than three companies to merge', 10000);
            }
            let params = {};
            params['company_ids'] = companyIds;
            $.ajax({
              type: 'POST',
              url: '/companies/merge?' + $.param(params),
              dataType: 'application/json',
              complete(result) { 
                let responseText = JSON.parse(result.responseText);
                $('#companies_table').DataTable().ajax.reload();
                ToastCustom('Merged', 'Company records merged', 5000);
              },
            });
          }
        });
      })
    }

  }

}